module.exports = __webpack_public_path__ + "static/img/gzhlks@2x.b7762ab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ym/gzhlks@2x.png
// module id = NmGN
// module chunks = 1